module.exports = __webpack_public_path__ + "img/djyiwang.d84857c3.png";